import { useEffect, useState } from 'react';
import { useDevicesStore } from '../store/devices/allDevices';
import { DeviceByGroupStore } from '../store/devices/DeviceByGroupStore';
import { useAuthStore } from '../store/auth/auth';

export function useDevicesLoader() {
    const { fetchDevicesByStore, allDevices, fetchAllDevices } = DeviceByGroupStore();
    const { user, SmartDVRToken } = useAuthStore();

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        fetchAllDevices(SmartDVRToken, user?.login!).finally(() => setIsLoading(false));
    }, [fetchAllDevices]);

    return { devices: allDevices, isLoading };
}
